import { CommonConstants } from './common/index';
import { DashboardConstants } from './dashboard';
import { PreferencesConstants } from './preferences';

export const HiTranslations = {
  ...CommonConstants,
  ...DashboardConstants,
  ...PreferencesConstants,
};
